import { UserType } from '~/utils/enum'
import tabBar from 'pages/tabBar/index.vue'
import home from 'pages/tabBar/home.vue'
import plugin from 'pages/tabBar/plugin.vue'
import other from 'pages/tabBar/other.vue'
import about from 'pages/tabBar/about.vue'
import personal from 'pages/user/user.vue'

const TabBar = [
  {
    name: 'TabBar',
    path: '/tabBar',
    component: tabBar,
    meta: {
      keepAlive: true
    },
    children: [
      {
        path: '',
        redirect: '/tabBar/home'
      },
      {
        name: 'Home',
        path: '/tabBar/home',
        component: home,
        meta: {
          title: '首页',
          keepAlive: true,
          index: 1
        }
      },
      {
        name: 'Plugin',
        path: '/tabBar/plugin',
        component: plugin,
        meta: {
          title: '插件',
          keepAlive: true,
          index: 2
        }
      },
      {
        name: 'Other',
        path: '/tabBar/other',
        component: other,
        meta: {
          title: '其他',
          keepAlive: true,
          index: 3
        }
      },
      {
        name: 'About',
        path: '/tabBar/about',
        component: about,
        meta: {
          title: '关于',
          keepAlive: true,
          index: 4
        }
      },
      {
        name: 'Personal',
        path: '/tabBar/personal',
        component: personal,
        meta: {
          title: '个人',
          keepAlive: true,
          rols: [UserType.Normal, UserType.Developer, UserType.Admin, UserType.StationMaster],
          index: 5
        }
      }
    ]
  }
]
export default TabBar
